export const SET_SETTINGS = 'BACKEND_SETTINGS_SET_SETTINGS'
export const SET_DOWNLOAD_EVERYTHING = 'BACKEND_SETTINGS_SET_DOWNLOAD_EVERYTHING'
export const SET_RUN_CLIENTS_WITH_LOGGING = 'BACKEND_SETTINGS_SET_RUN_CLIENTS_WITH_LOGGING'
export const SET_RUN_CLIENTS_WITH_DX9 = 'BACKEND_SETTINGS_SET_RUN_CLIENTS_WITH_DX9'
export const SET_SHOULD_MINIMIZE_TO_TRAY = 'BACKEND_SETTINGS_SET_SHOULD_MINIMIZE_TO_TRAY'
export const SET_LOCALE = 'BACKEND_SETTINGS_SET_LOCALE'
export const SET_TEST_SERVERS = 'BACKEND_SETTINGS_SET_TEST_SERVERS'



// WEBPACK FOOTER //
// ./src/features/Backend/data/settings/constants.js